<template>
	<div class="index-contain cont">
		<div class="header">
			<img src="@/assets/img/logo.png">{{title}}
      <div class="swiper-box">
      <div class="m-warning swiper-container" v-if="warningObj.length > 0">
        <div class="warn-swiper" id="warn-swiper">
          <div class="warn_conten swiper-slide" v-for="(item,index) in warningObj" :key="index">
            <img v-bind:src="'static/images/warning/'+item.alarm_type+'' +item.alarm_level+'.png'" onerror="this.src='./static/images/err-img.png'" />
            <div class="warn_txt">
              <h4>{{item.alarm_title}}</h4>
              <span><p class="container_words">{{item.alarm_content}}</p></span>
            </div>
          </div>
        </div>
      </div>
      </div>
		</div>
		<div class="container">
			<div v-if="userInfo.data">
				<div class="schoolname">
					<label>{{userInfo.data.schoolName}} </label>
					<!-- <div class="swiper-box">
						<div class="swiper-container" id="warningSwiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item,index) in warningObj" :key="index">
									<img v-bind:src="'static/images/warning/'+item.alarm_type+'' +item.alarm_level+'.png'" onerror="this.src='./static/images/err-img.png'" />
								</div> -->
								<!-- <div class="swiper-slide">
									<img src="@/assets/img/yj.png"  />
								</div> -->
							<!-- </div>
						</div>
					</div> -->
				</div>
				<div class='time'>
					更新时间：{{liveInformationObj.times}}
          <el-popover
            placement="right"
            width="400"
            trigger="click">
            <el-row>
            <el-col :span="22">
              <el-date-picker
                    v-model="expDate"
                     size="mini"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                  </el-col>
                  <el-col :span="2">
                  <download-excel
                  class="excel"
                  :fetch="fetchData"
                  :fields="json_fields"
                  :before-generate = "startDownload"
                  :before-finish   = "finishDownload"
                  name="校园站历史数据.xls">
                  <el-button icon="el-icon-search" type="info" size="mini" circle></el-button>
                  </download-excel>
                  </el-col>
                  </el-row>
            <el-button icon="el-icon-upload" type="text" circle slot="reference"></el-button>
          </el-popover>
				</div>
				<div class='line'></div>
				<div class='detail' :class="{'trsdshow':trsdshow==true}">
					<div class='detail-say'>
						<label class="det-img"><img src="@/assets/img/temp.png" alt=""></label>
            <!-- <el-popover
              placement="right"
              trigger="click">
              <div id="qwchart"></div> -->
              <label>气温：<span>{{liveInformationObj.weather}}</span></label>
            <!-- </el-popover> -->

					</div>
					<div class='detail-say'>
						<label class="det-img"><img src="@/assets/img/sd.png" alt=""></label>
						<label>相对湿度：<span>{{liveInformationObj.xdsd}}</span></label>
					</div>
					<div class='detail-say'>
						<label class="det-img"><img src="@/assets/img/qy.png" alt=""></label>
						<label>气压：<span>{{liveInformationObj.pressure}}</span></label>
					</div>
					<div class='detail-say'>
						<label class="det-img"><img src="@/assets/img/windd.png" alt=""></label>
						<label>风速：<span>{{liveInformationObj.windDirectionObj}}({{parseInt(liveInformationObj.windDirectionObj)}}m/s)</span></label>
					</div>
					<div class='detail-say'>
						<label class="det-img"><img src="@/assets/img/windv.png" alt=""></label>
						<label>风向：<span>{{liveInformationObj.windPowerObj}}</span></label>
					</div>
					<!-- <div class='detail-say'>
						<label class="det-img"><img src="@/assets/img/yl.png" alt=""></label>
						<label>雨量：<span>{{liveInformationObj.xsjs}}</span></label>
					</div> -->
					<div class='detail-say'>
						<label class="det-img"><img src="@/assets/img/uv.png" alt=""></label>
						<label>紫外线强度：<span>{{liveInformationObj.zwx}}</span></label>
					</div>
					<div class='detail-say'>
						<label class="det-img"><img src="@/assets/img/envir.png" alt=""></label>
						<label>环境光强度：<span>{{liveInformationObj.hjg}}</span></label>
					</div>
          <div class='detail-say' v-if="njdshow">
          	<label class="det-img"><img src="@/assets/img/njd-icon.png" alt=""></label>
          	<label>能见度：<span>{{liveInformationObj.njd}}</span></label>
          </div>
          <div class='detail-say' v-if="rzssshow">
          	<label class="det-img"><img src="@/assets/img/envir.png" alt=""></label>
          	<label>日照时数：<span>{{liveInformationObj.rzss}}</span></label>
          </div>
					<div class='detail-say' v-if="trsdshow">
						<label class="det-img"><img src="@/assets/img/trwd-icon.png" alt=""></label>
						<label>土壤湿度：</label>

					</div>
					<p v-if="trsdshow">10cm:<span>{{liveInformationObj.trsd10}}，</span>20cm:<span>{{liveInformationObj.trsd20}}，</span>30cm:<span>{{liveInformationObj.trsd30}}</span></p>
					<div class='detail-title'>
						气象要素
					</div>
					<div class='line'></div>
				</div>
				<div class='detail' v-show="xdmshow">
					<div class='detail-say'>
						<label class="det-img"><img src="@/assets/img/sn.png" alt=""></label>
						<label>水泥路面温度：<span>{{liveInformationObj.snlm}}</span></label>
					</div>
					<div class='detail-say'>
						<label class="det-img"><img src="@/assets/img/cp.png" alt=""></label>
						<label>草面温度：<span>{{liveInformationObj.cpwd}}</span></label>
					</div>
					<div class='detail-say nomgb'>
						<label class="det-img"><img src="@/assets/img/runline.png" alt=""></label>
						<label>塑胶跑道温度：<span>{{liveInformationObj.pdwd}}</span></label>
					</div>
					<div class='detail-title short'>
						下垫面
					</div>

				</div>
			</div>
			<div>
				<div class="tutu">
					<div class="tutu-name">{{minTimes}}—{{maxTimes}}要素曲线图</div>
					<div class="tuechart" id='valuechart'>
					</div>
				</div>
				<div class="tutu2">
					<div class="sevenechart  nomgb">
						<div class="daynight div">
							<div>白<br />天</div>
							<div>夜<br />晚</div>
						</div>
						<div class="div" v-for="(item,index) in weekData.date" :key="index">
							<div class="week">{{weekData.date[index]}}</div>
							<div class="date">{{weekData.time[index]}}</div>
							<div class="imgsay">
								<img :src='"@/assets/img/weather/day/"+ weekData.weatherD[index] +".png"' alt="">
							</div>
							<div class="imgsay0">
								<img :src='"@/assets/img/weather/night/"+ weekData.weatherN[index] +".png"'>
							</div>
						</div>

						<div class="sevenechartcont" id='sevenchart'></div>
					</div>
					<div class="qiuechart">
						<!-- <div id='rollechart'></div> -->
						<div class="swiper-container" id="qiuechartSwiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class='rollechart'></div>
								</div>
								<div class="swiper-slide">
									<div class='rollechart1'></div>
								</div>
								<div class="swiper-slide">
									<div class='rollechart2'></div>
								</div>
								<div class="swiper-slide">
									<div class='rollechart3'></div>
								</div>
								<div class="swiper-slide">
									<div class='rollechart4'></div>
								</div>
							</div>
						</div>
						<div class="add">
							<img src="@/assets/img/qiu.png" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footer">
			<img src="@/assets/img/cs.png">
		</div>
	</div>

</template>

<script>
	import Swiper from "swiper"
	import "swiper/dist/css/swiper.min.css"
	import 'swiper/dist/js/swiper.min.js'
	import echartsLiquidfill from 'echarts-liquidfill' //在这里引入
	var that;
	export default {
		name: "Index",
		data:function() {
			return {
        intervalId:null,
        json_fields:{
          "时间":"time",
          "气温":{
            field: "data.A01.avg",
            callback: (value) => {
                return value?parseFloat(value).toFixed(1):"";
            }
          },
          "相对湿度":{
            field: "data.A02.avg",
            callback: (value) => {
                 return value?parseFloat(value).toFixed(1):"";
            }
          },
          "气压":{
            field: "data.A03.avg",
            callback: (value) => {
                 return value?parseFloat(value).toFixed(1):"";
            }
          },
          "风速":{
            field: "data.A11.avg",
            callback: (value) => {
                 return value?parseFloat(value).toFixed(1):"";
            }
          },
          "风向":{
            field: "data.A13",
            callback: (value) => {
              if(value!=null){
                if(value==0){
                  return "北";
                }else if(value==1){
                  return "北东北";
                }else if(value==2){
                  return "东北";
                }else if(value==3){
                  return "东东北";
                }else if(value==4){
                  return "东";
                }else if(value==5){
                  return "东东南";
                }else if(value==6){
                  return "东南";
                }else if(value==7){
                  return "南东南";
                }else if(value==8){
                  return "南";
                }else if(value==9){
                  return "南西南";
                }else if(value==10){
                  return "西南";
                }else if(value==11){
                  return "西西南";
                }else if(value==12){
                  return "西";
                }else if(value==13){
                  return "西西北";
                }else if(value==14){
                  return "西北";
                }else if(value==15){
                  return "北西北";
                }else if(value==16){
                  return "静风";
                }
              }else{
               return "";
            }
          }
          },
          "雨量":"data.A14.sum",
          "环境光强度":{
            field: "data.A04.avg",
            callback: (value) => {
                 return value?parseFloat(value).toFixed(1):"";
            }
          },
          "紫外线强度":{
            field: "data.A09.avg",
            callback: (value) => {
                 return value?parseFloat(value).toFixed(1):"";
            }
          },
          "草面温度":{
            field: "data.X01.avg",
            callback: (value) => {
                 return value?parseFloat(value).toFixed(1):"";
            }
          },
          "水泥面温度":{
            field: "data.X02.avg",
            callback: (value) => {
                 return value?parseFloat(value).toFixed(1):"";
            }
          },
          "塑胶面温度":{
            field: "data.X03.avg",
            callback: (value) => {
                 return value?parseFloat(value).toFixed(1):"";
            }
          },
          "最高气温":{
            field: "data.A01.max",
            callback: (value) => {
                return value?parseFloat(value).toFixed(1):"";
            }
          },
          "最高气温出现时间":{
            field: "data.A01.max_time",
            callback: (value) => {
                return value?this.formatDateByTimes(value,'yyyy-MM-dd hh:mm'):"";
            }
          },
          "最低气温":{
            field: "data.A01.min",
            callback: (value) => {
                return value?parseFloat(value).toFixed(1):"";
            }
          },
          "最低气温出现时间":{
            field: "data.A01.min_time",
            callback: (value) => {
                return value?this.formatDateByTimes(value,'yyyy-MM-dd hh:mm'):"";
            }
          },
          "最大湿度":{
            field: "data.A02.max",
            callback: (value) => {
                return value?parseFloat(value).toFixed(1):"";
            }
          },
          "最大湿度出现时间":{
            field: "data.A02.max_time",
            callback: (value) => {
                return value?this.formatDateByTimes(value,'yyyy-MM-dd hh:mm'):"";
            }
          },
          "最小湿度":{
            field: "data.A02.min",
            callback: (value) => {
                return value?parseFloat(value).toFixed(1):"";
            }
          },
          "最小湿度出现时间":{
            field: "data.A02.min_time",
            callback: (value) => {
                return value?this.formatDateByTimes(value,'yyyy-MM-dd hh:mm'):"";
            }
          }
          // "10cm土壤湿度":{
          //   field: "data.A17_10.avg",
          //   callback: (value) => {
          //        return value?parseFloat(value).toFixed(1):"";
          //   }
          // },
          // "10cm土壤温度":{
          //   field: "data.A27_10.avg",
          //   callback: (value) => {
          //        return value?parseFloat(value).toFixed(1):"";
          //   }
          // },
          // "20cm土壤湿度":{
          //   field: "data.A17_20.avg",
          //   callback: (value) => {
          //        return value?parseFloat(value).toFixed(1):"";
          //   }
          // },
          // "20cm土壤温度":{
          //   field: "data.A27_20.avg",
          //   callback: (value) => {
          //        return value?parseFloat(value).toFixed(1):"";
          //   }
          // },
          // "30cm土壤湿度":{
          //   field: "data.A17_30.avg",
          //   callback: (value) => {
          //        return value?parseFloat(value).toFixed(1):"";
          //   }
          // },
          // "30cm土壤温度":{
          //   field: "data.A27_30.avg",
          //   callback: (value) => {
          //        return value?parseFloat(value).toFixed(1):"";
          //   }
          // },
        },
				valuechart: '',
				sevenchart: '',
				rollechart: '',
				rollechart1: '',
				rollechart2: '',
				rollechart3: '',
				rollechart4: '',
				rollechartObj: '',
				rollechart1Obj: '',
				rollechart2Obj: '',
				rollechart3Obj: '',
				rollechart4Obj: '',
				icons: [require('@/assets/img/wds.png'), require('@/assets/img/ws.png'), require('@/assets/img/yls.png'), require(
					'@/assets/img/fengxiang.png')],
				userInfo: {}, //用户信息
				liveInformationObj: {}, //实况
				weekData: {}, //七天
				minTimes: '', //24小时数据最小时间
				maxTimes: '', //24小时数据最大时间
				swiperShow: true, //判断是否存在预警
				warningObj: {},
				trsdshow:false,
        xdmshow:true,
        njdshow:false,
        rzssshow:false,
        title:'智慧校园气象数据展示平台',
        pickerOptions: {
                  shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近一个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近三个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                      picker.$emit('pick', [start, end]);
                    }
                  }]
                },
        expDate:[]
			}

		},

		mounted() {
      that = this;
      // 计时器正在进行中，退出函数
       if (this.intervalId != null) {
          return;
       }
       that.dataRefreh();
        // 计时器为空，操作
        this.intervalId = setInterval(() => {
           //console.log("刷新" + new Date());
           that.dataRefreh();
           //that.$router.go(0)  //每五分钟调用方法刷新一次页面，进行数据更新
          }, 180000);
    },
    unmounted() {
       // 销毁组件之前，清除计时器
       this.clear();
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId);//清除计时器
      this.intervalId = null; //设置为null
    },
		methods: {
      dataRefreh(){
        that = this;
        var query = decodeURI(window.location.search.substring(1));
        var vars = query.split(/\?|\&|\=/g);
        var b = {};
        for (var i = 0; i < vars.length; i = i + 2) {
        	b[vars[i]] = vars[i + 1];
        }

        if (vars[0] == "") {
        	this.userInfo = {
        		"key": "XY330783001"
        	}
        } else {
        	this.userInfo = b;
        }
        // this.userInfo = {
        // 	"key": "XY330783001"
        // }
        this.getcityObj();
        $(window).resize(function() {
        	// that.drawyaosuEchart();
        	// that.drawseventEchart();
        	that.drawballEchart();
        });
        // that.drawyaosuEchart();
        // that.drawseventEchart();
        // that.drawballEchart();
        // that.drawballEchart1();
        // that.drawballEchart2();
        // that.drawballEchart3();
        // that.drawballEchart4();
        that.banner();
        // that.yschart('#qwchart');
      },
			//获取区域地点
			getcityObj() {
				var that = this;
				requestData('./static/data/user.json', 'get', '', function(res) {
					var b = res[that.userInfo.key];
					that.$set(that.userInfo, "data", b);

					that.getLoginObj();
					// that.getMapWarning(that.userInfo.data.areaName);
					that.getOndayObj(that.userInfo.data.stationNum);
					document.title = that.userInfo.data.schoolName
          if(that.userInfo.data.title){
            that.title=that.userInfo.data.title
          }
				})
			},
			// 登录
			getLoginObj() {
				var that = this;
				var newUrl = baseUrl + 'login/login?username=dingw@grassinfo.cn&password=argus@87134963';
				requestData(newUrl, 'get', '', function(res) {
					that.sessionId = res.sessionId;
					localStorage.setItem('key', that.sessionId);
					that.getStationObj(that.sessionId);
				})
			},
			getStationObj(sessionId) {
				var that = this;
				var newUrl = baseUrl + 'basic/queryNodes?sessionId=' + sessionId;
				// newUrl = encodeURIComponent(newUrl)
				requestData(newUrl, 'get', '', function(res) {
					if (res.message == "查询成功！") {
						var resData = res.responseBody;
						var resDataAll = resData.datas;
						resDataAll.map((item, index) => {
							if (item.data["no."] == that.userInfo.key) {
								that.$set(that.userInfo, "codeId", item.code);
							}

						})
						that.getRealWeather(sessionId);
						that.get24HourLiveData(sessionId);

					}
				})
			},
			// 实况
			getRealWeather(sessionId) {
				var that = this;
				var newUrl = baseUrl + 'minute/queryLast?sessionId=' + sessionId + '&code=' + that.userInfo.codeId;
				// newUrl = encodeURIComponent(newUrl)
				requestData(newUrl, 'get', '', function(res) {
					if (res.message == "查询成功！") {
						if(that.userInfo.data.trwsd == true){
							that.trsdshow = true;
						}else{
							that.trsdshow = false;
						}
            if(that.userInfo.data.xdm == false){
            	that.xdmshow = false;
            }else{
            	that.xdmshow = true;
            }
            if(that.userInfo.data.njd == true){
            	that.njdshow = true;
            }else{
            	that.njdshow = false;
            }
            if(that.userInfo.data.rzss == true){
            	that.rzssshow = true;
            }else{
            	that.rzssshow = false;
            }
						var resData = res.responseBody.datas;
						resData.map((item, index) => {
							if (item.data.A01 == undefined) {
								that.$set(that.liveInformationObj, "weather", "暂缺");
							} else {
								that.$set(that.liveInformationObj, "weather", item.data.A01 + "℃");
							}

							if (item.data.A02 == undefined) {
								that.$set(that.liveInformationObj, "xdsd", "暂缺");
							} else {
								that.$set(that.liveInformationObj, "xdsd", item.data.A02 + '%');
							}
							if (item.data.A03 == undefined) {
								that.$set(that.liveInformationObj, "pressure", "1020hPa");
							} else {
								that.$set(that.liveInformationObj, "pressure", parseInt(item.data.A03) + 'hPa');

							}
							if (item.data.A04 == undefined) {
								that.$set(that.liveInformationObj, "hjg", "5lx");
							} else {
								that.$set(that.liveInformationObj, "hjg", parseInt(item.data.A04) + 'lx');

							}
							if (item.data.A09 == undefined) {
								that.$set(that.liveInformationObj, "zwx", "暂缺");
							} else {
								that.$set(that.liveInformationObj, "zwx", parseInt((item.data.A09)));

							}
							if (item.data.X01 == undefined) {
								that.$set(that.liveInformationObj, "cpwd", "暂缺");
							} else {
								that.$set(that.liveInformationObj, "cpwd", item.data.X01 + '℃');

							}
							if (item.data.X02 == undefined) {
								that.$set(that.liveInformationObj, "snlm", "暂缺");
							} else {
								that.$set(that.liveInformationObj, "snlm", item.data.X02 + '℃');

							}
							if (item.data.X03 == undefined) {
								that.$set(that.liveInformationObj, "pdwd", "暂缺");
							} else {
								that.$set(that.liveInformationObj, "pdwd", item.data.X03 + '℃');

							}
							if (item.data.A17_10 == undefined) {
								that.$set(that.liveInformationObj, "trsd10", "暂缺");
							} else {
								that.$set(that.liveInformationObj, "trsd10", item.data.A17_10 + '%');

							}
							if (item.data.A17_20 == undefined) {
								that.$set(that.liveInformationObj, "trsd20", "暂缺");
							} else {
								that.$set(that.liveInformationObj, "trsd20", item.data.A17_20 + '%');

							}
							if (item.data.A17_30 == undefined) {
								that.$set(that.liveInformationObj, "trsd30", "暂缺");
							} else {
								that.$set(that.liveInformationObj, "trsd30", item.data.A17_30 + '%');

							}
              if (item.data.A21 == undefined) {
              	that.$set(that.liveInformationObj, "njd", "暂缺");
              } else {
              	that.$set(that.liveInformationObj, "njd", item.data.A21+'米');
              }
              if (item.data.A31 == undefined) {
              	that.$set(that.liveInformationObj, "rzss", "暂缺");
              } else {
              	that.$set(that.liveInformationObj, "rzss", item.data.A31+'小时');
              }
							if (item.data.A11 == undefined) {
								var oldTimeData = localStorage.getItem('nowTimes') ? localStorage.getItem('nowTimes') : 0;
								var nowTimeData = new Date().getTime();
								if (nowTimeData - oldTimeData < 1000 * 60 * 15) {
									that.$set(that.liveInformationObj, "windDirectionObj", localStorage.getItem('windDirectionData'));
									that.$set(that.liveInformationObj, "windPowerObj", localStorage.getItem('windPowerData'));
								}
							} else {
								that.$set(that.liveInformationObj, "windDirectionObj", flObj(item.data.A11));
								that.$set(that.liveInformationObj, "windPowerObj", fxObj(item.data.A13));
								localStorage.setItem('windDirectionData', that.liveInformationObj.windDirectionObj);
								localStorage.setItem('windPowerData', that.liveInformationObj.windPowerObj);
								localStorage.setItem('nowTimes', new Date().getTime());
							}
							if (item.data.A14 == undefined) {
								var oldTimeData = localStorage.getItem('nowTimes') ? localStorage.getItem('nowTimes') : 0;
								var nowTimeData = new Date().getTime();
								if (nowTimeData - oldTimeData < 1000 * 60 * 15) {
									that.$set(that.liveInformationObj, "xsjs", localStorage.getItem('liveInformation'));
								}
							} else {
								that.$set(that.liveInformationObj, "xsjs", item.data.A14 + 'mm');
								localStorage.setItem('liveInformation', that.liveInformationObj.xsjs);
								localStorage.setItem('nowTimes', new Date().getTime());
							}

							that.$set(that.liveInformationObj, "zwx", zwxObj((item.data.A09*10)));
							that.$set(that.liveInformationObj, "times", item.time);
						})

					}
				})
			},
			//七天
			getOndayObj(userArea) {
				var that = this;
				var d = {
					date: [],
					time: [],
					weatherD: [],
					weatherN: [],
					windD: [],
					windF: [],
					maxTemp: [],
					minTemp: [],
				};
				//var url = 'https://www.hzqx.com/hztq/data/forecastIndex7DData/' + userArea + '.json';
        var url='https://v1.yiketianqi.com/api?unescape=1&version=v91&appid=71228218&appsecret=8sktelwT&cityid='+userArea;
				requestData(url, 'get', '', function(res) {
					// var weekend = ["日", "一", "二", "三", "四", "五", "六"];
          var data =res.data;
					if (data.length > 0) {
						data.map(function(item, index) {
							if (item.date == new Date().format("yyyy-MM-dd")) {
								d.date.push('今天');
                that.getWarning(item.alarm);
							} else {
								//let date = item.date.substring(0, 4) + "/" + item.date.substring(4, 6) + "/" + item.date.substring(6, 8);
								//date = "星期" + weekend[new Date(item.date).getDay()];
								d.date.push(item.week);
							}
							let date = item.date.substring(5, item.date.length)
							d.time.push(date);
							d.weatherD.push(item.wea_day);
							d.weatherN.push(item.wea_night);
							d.maxTemp.push(item.tem1);
							d.minTemp.push(item.tem2);
						})
					}
					that.weekData = d;
					that.weatherChart(d.maxTemp, d.minTemp);
				})
			},
			//24小时实况
			get24HourLiveData(sessionId) {
				var that = this;
				var startTime = new Date(new Date().getTime() - 24 * 3600 * 1000).format("yyyy-MM-dd hh");
				var endTime = new Date().format("yyyy-MM-dd hh");
				var newUrl = baseUrl + 'hour/queryByTime?sessionId=' + sessionId + '&start=' + startTime + '&end=' + endTime +
					'&code=' + that.userInfo.codeId;
				// newUrl = encodeURIComponent(newUrl)
				// requestData(baseUrlAll + newUrl, 'get', '', function(res) {


				// var url = "http://radar.grassinfo.cn:8818/apiTest/nbwechat/appid/dataposition";
				// var data = {
				// 	url: baseUrl + 'hour/queryByTime',
				// 	data:JSON.stringify({
				// 		sessionId:sessionId,
				// 		start: startTime,
				// 		end: endTime,
				// 		code: that.userInfo.codeId
				// 	})
				// }

				requestData(newUrl, 'get', '', function(res) {
					var xarr = [],
						rainArr = [],//24小时雨量
						tempArr = [],//24小时温度
            sdArr=[],//24小时湿度
            qyArr=[],//24小时气压
            zwxArr=[],//24小时紫外线
            hjgArr=[],//24小时环境光
            snmArr=[],//24小时水泥面
            cmArr=[],//24小时草面
            sjmArr=[],//24小时塑胶面
						flObjObj = '',
						obj,
						windSpeedList = [];
					if (res.message == "查询成功！") {
						var resData = res.responseBody.datas;
						resData.map((item, index) => {
							var time = item.time.replace(/-/g, "/");
							var d = "";
							time = new Date(time).format("hh时");
							xarr.push(time);
							d = item.data.A14.sum ? parseFloat(parseFloat(item.data.A14.sum).toFixed(1)) : ""
							rainArr.push(d)
							d = item.data.A01.avg ? parseFloat(parseFloat(item.data.A01.avg).toFixed(1)) : ""
							tempArr.push(d)
              if(item.data.A11)
							flObjObj = parseInt(flObj(Math.floor(item.data.A11.avg * 10) / 10))
              d = item.data.A02.avg ? parseFloat(parseFloat(item.data.A02.avg).toFixed(1)) : ""
							sdArr.push(d)
              //临时
              if(item.data.A03){
              d = item.data.A03.avg ? parseFloat(parseFloat(item.data.A03.avg).toFixed(1)) : ""
              }else{
                d =1020;
              }
              qyArr.push(d)
              d = item.data.A09.avg ? parseFloat(parseFloat(item.data.A09.avg).toFixed(1)) : ""
              zwxArr.push(d)
              d = item.data.A04.avg ? parseFloat(parseFloat(item.data.A04.avg).toFixed(1)) : ""
              hjgArr.push(d)
              if(item.data.X01){
                d = item.data.X01.avg ? parseFloat(parseFloat(item.data.X01.avg).toFixed(1)) : ""
                snmArr.push(d)
              }
              if(item.data.X02){
                d = item.data.X02.avg ? parseFloat(parseFloat(item.data.X02.avg).toFixed(1)) : ""
                cmArr.push(d)
              }
              if(item.data.X03){
                d = item.data.X03.avg ? parseFloat(parseFloat(item.data.X03.avg).toFixed(1)) : ""
                sjmArr.push(d)
              }
							// if(flObjObj == 0){
							// 	flObjObj = ''
							// }

							obj = {
								value: flObjObj,
								//value: Math.round((item.data.A11.avg)*10)/10,
								symbolRotate: num2windD(item.data.A13)
							}
							windSpeedList.push(obj);
						})
						that.minTimes = resData[0].time.split(" ")[0].split("-")[1] + '月' + resData[0].time.split(" ")[0].split("-")[2] +
							'日' + resData[0].time.split(" ")[1].split(":")[0] + '时';
						that.maxTimes = resData[resData.length - 1].time.split(" ")[0].split("-")[1] + '月' + resData[resData.length - 1]
							.time.split(" ")[0].split("-")[2] + '日' + resData[resData.length - 1].time.split(" ")[1].split(":")[0] + '时'
						var updateTime = '更新时间：' + that.liveInformationObj.times.substring(5);
						var len=resData.length;
            that.rollechartObj = '暂无数据'
            that.rollechart1Obj = '暂无数据'
            that.rollechart2Obj = '暂无数据'
            that.rollechart3Obj = '暂无数据'
            that.rollechart4Obj = '暂无数据'
            var sum=0.0;
            for(var i=len-1;i>=0;i--){
              sum+=parseFloat(resData[i].data.A14.sum);
              if(i==len-1){//一小时雨量
                 that.rollechartObj = sum;
              }else if(i==len-3){//3小时雨量
                that.rollechart1Obj = sum;
              }else if(i==len-6){//6小时雨量
                that.rollechart2Obj =sum;
              }else if(i==len-12){//12小时雨量
                that.rollechart3Obj =sum;
              }else if(i==len-24){//24小时雨量
                that.rollechart4Obj =sum;
              }
            }
      //       if (resData[0]) {
						// 	that.rollechartObj = resData[0].data.A14.sum ? parseFloat((resData[0].data.A14.sum) / 100).toFixed(1) : "";
						// } else {
						// 	that.rollechartObj = '暂无数据'
						// }
						// if (resData[2]) {

						// 	that.rollechart1Obj = resData[2].data.A14.sum ? parseFloat((resData[2].data.A14.sum) / 100).toFixed(1) : "";
						// } else {
						// 	that.rollechart1Obj = '暂无数据'
						// }
						// if (resData[5]) {
						// 	that.rollechart2Obj = resData[5].data.A14.sum ? parseFloat((resData[5].data.A14.sum) / 100).toFixed(1) : "";
						// } else {
						// 	that.rollechart2Obj = '暂无数据'
						// }
						// if (resData[11]) {
						// 	that.rollechart3Obj = resData[11].data.A14.sum ? parseFloat((resData[11].data.A14.sum) / 100).toFixed(1) : "";
						// } else {
						// 	that.rollechart3Obj = '暂无数据'
						// }
						// if (resData[23]) {
						// 	that.rollechart4Obj = resData[23].data.A14.sum ? parseFloat((resData[11].data.A14.sum) / 100).toFixed(1) : "";
						// } else {
						// 	that.rollechart4Obj = '暂无数据'
						// }
					}
					// if (that.rollechartObj >= 1) {
					// 	that.rollechartObj = 1;
					// }
					that.drawyaosuEchart(xarr, rainArr, tempArr, updateTime, windSpeedList);
					that.drawballEchart(that.rollechartObj);
					that.drawballEchart1(that.rollechart1Obj);
					that.drawballEchart2(that.rollechart2Obj);
					that.drawballEchart3(that.rollechart3Obj);
					that.drawballEchart4(that.rollechart4Obj);
					var swiper = new Swiper('#qiuechartSwiper', {
						initialSlide: 0,
						autoplay: {
							disableOnInteraction: false, //默认true
							delay: 2000, //默认3000
						},
						slidesPerView: 1,
						spaceBetween: 30,
						centeredSlides: true,
						observer: true, //修改swiper自己或子元素时，自动初始化swiper
						observeParents: true //修改swiper的父元素时，自动初始化swiper
					});
				})
			},
			//绘制要素图表
			drawyaosuEchart(xarr, rainArr, tempArr, updateTime, windSpeedList) {
				var dom = document.querySelector("#valuechart");
				that.valuechart = that.$echarts.init(dom);
				var colors = ['#FD7EBA', '#ffe2a9', '#56bdff'];
				var option = {
					color: colors,
					title: {
						text: updateTime,
						textStyle: {
							color: '#fff',
							fontSize: 12,
							fontWeight: 'normal'
						},
						right: '10%'
					},
					tooltip: {
						trigger: "axis",
						position: function(pos, params, dom, rect, size) {
							return [pos[0] - size.contentSize[0] / 2, pos[1] - size.contentSize[1]];
						},
						textStyle: {
							fontSize: 9
						},
					},
					grid: {
						right: '10%',
						top: 80,
						bottom: 24,
						left: '5%'
					},
					legend: {
						data: [{
								name: '气温（℃）',
								icon: 'image://' + that.icons[0]
							},
							{
								name: '风速（m/s）',
								icon: 'image://' + that.icons[1]
							},
							{
								name: '雨量（mm）',
								icon: 'image://' + that.icons[2]
							},

						],
						selected:{
							'气温（℃）':true,
							'风速（m/s）':false,
							'雨量（mm）':true
						},
						right: '10%',
						top: 24,
						textStyle: {
							color: '#fff',
							fontSize: 12
						}
					},
					xAxis: [{
						type: 'category',
						axisTick: {
							alignWithLabel: true
						},
						data: xarr,
						axisLabel: {
							textStyle: {
								//改变刻度字体样式
								color: "#fff",
								fontSize: 12 //x轴文字大小
							},
							//  formatter: function(val) {
							//   val=val.replace(/-/g, '/');
							// return new Date(val).Format("hh:mm");
							//  }
						},
						axisLine: {
							lineStyle: {
								color: "#fff"
							}
						},
						splitLine: { //网格线
							show: false
						},
						axisTick: {
							show: false
						},

					}],
					yAxis: [{
							type: 'value',
							name: ' ℃',
							min: function(value) {
								return value.min;
							},
							max: function(value) {
								return value.max;
							},
							position: 'right',
							axisLine: {
								lineStyle: {
									color: '#fff'
								}
							},
							splitLine: { //网格线
								show: false
							},
							axisLabel: {
								// formatter: '{value} ml'
							}
						},
						{
							type: 'value',
							name: 'm/s',
							splitLine: { //网格线
								show: false
							},
							minInterval: 1,
							min: function(value) {
								return value.min;
							},
							max: function(value) {
								return value.max;
							},
							position: 'right',
							axisLine: {
								lineStyle: {
									color: '#fff'
								}
							},
							offset: 50,
							axisLabel: {
								// formatter: '{value} °C'
							}

						},
						{
							type: 'value',
							name: 'mm',
							splitLine: { //网格线
								show: false
							},
							min: function(value) {
								return value.min;
							},
							max: function(value) {
								return value.max;
							},
							position: 'left',
							axisLine: {
								lineStyle: {
									color: '#fff'
								}
							},
							axisLabel: {
								// formatter: '{value} ml'
							}
						}
					],
					series: [{
							name: '气温（℃）',
							type: 'line',
							smooth: true,
							data: tempArr,
							lineStyle: {
								color: '#FD7EBA'
							},
							symbolSize: 0,
							label: {
								show: false,
								color: '#fff',
								fontSize: 12

							}
						},
						{
							name: '风速（m/s）',
							type: 'line',
							yAxisIndex: 1,
							symbol: 'arrow',
							symbolOffset: [0, -3.5],
							symbolSize: 12,
							data: windSpeedList,
							lineStyle: {
								normal: {
									color: '#ffe2a9'
								}
							},
							itemStyle: {
								normal: {
									color: function(params) {
										var colorList = ['#ffe2a9', 'transparent'];
										if(params.data.value == 0){
											return colorList[1]
										}else{
											return colorList[0]
										}

									}
								}
							},
						},
						{
							name: '雨量（mm）',
							type: 'bar',
							yAxisIndex: 2,
							data: rainArr,
							itemStyle: {
								barBorderRadius: [20, 20, 0, 0],
								color: {
									type: "linear",
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
											offset: 0,
											color: "#6deaeb", // 0% 处的颜色

										},
										{
											offset: 0.5,
											color: "#529eb3", // 0% 处的颜色

										},
										{
											offset: 1,
											color: "#2d5061", // 100% 处的颜色

										}
									],
									global: false // 缺省为 false
								}
							},
							label: {
								show: true,
								color: '#fff',
								fontSize: 12,
								position: 'top'

							}
						}

					]
				};
				that.valuechart.setOption(option);
				window.setTimeout(function() {
					that.valuechart.resize();
				}, 200)


			},
			//绘制七天图表
			weatherChart(maxD, minD) {
				var dom = document.querySelector("#sevenchart");
				that.sevenchart = that.$echarts.init(dom);
				var option = {
					color: ['#37A2DA', '#9FE6B8'],
					grid: {
						top: '30',
						bottom: '30',
						left: '8%',
						right: '8%'
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						show: false,
					}],
					yAxis: [{
						type: 'value',
						show: false,
						min: function(value) {
							return value.min;
						},
						max: function(value) {
							return value.max;
						}
					}],
					series: [{
						name: '白天',
						type: 'line',
						showSymbol: true,
						symbolSize: 8,
						symbol: 'circle',
						hoverAnimation: true,
						data: maxD,
						smooth: true,
						itemStyle: {
							normal: {
								color: '#c5a8f7', //改变折线点的颜色
								lineStyle: {
									color: '#9d72e4' //改变折线颜色
								},
								label: {
									show: true,
									position: 'top',
									formatter: function(val) { //yOldData

										return val.value + "℃"
									},
									textStyle: {
										color: '#fff'
									}
								}
							}
						}
					}, {
						name: '晚上',
						type: 'line',
						data: minD,
						showSymbol: true,
						symbolSize: 8,
						symbol: 'circle',
						hoverAnimation: true,
						smooth: true,
						itemStyle: {
							normal: {
								color: '#9ce5f1', //改变折线点的颜色
								lineStyle: {
									color: '#71c7d5' //改变折线颜色
								},
								label: {
									show: true,
									formatter: function(val) { //yOldData
										return val.value + "℃"
									},
									textStyle: {
										color: '#fff'
									},
									position: 'bottom'
								}
							}
						}
					}]
				};
				that.sevenchart.setOption(option);
				window.setTimeout(function() {
					that.sevenchart.resize();
				}, 200)
			},
			//绘制水球图表
			drawballEchart(item) {
				var dom = document.querySelector(".rollechart");
				that.rollechart = that.$echarts.init(dom);
				if (item == '暂无数据') {
					var value = [0, 0]
				} else {
          item=item/100;
					var value = [item, item]
				}
				var option = {

					series: [{
						type: 'liquidFill', //类型
						radius: '80%',
						data: value, //数据是个数组 数组的每一项的值是0-1
						outline: {
							show: true, //是否显示轮廓 布尔值
							borderDistance: 0, //外部轮廓与图表的距离 数字
							itemStyle: {
								//borderColor:'#5aa9d1', //边框的颜色
								borderColor: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(85, 144, 176, 1)'
									}, {
										offset: 0.5,
										color: 'rgba(85, 144, 176, .25)'
									}, {
										offset: 1,
										color: 'rgba(85, 144, 176, 1)'
									}],
									globalCoord: false
								},
								borderWidth: 0, //边框的宽度
								//shadowBlur: 25 , //外部轮廓的阴影范围 一旦设置了内外都有阴影
								//shadowColor: '#000' //外部轮廓的阴影颜色
							}
						},
						backgroundStyle: {
							//color:'rgba(36,71,95,0.5)',//图表的背景颜色
							color: {
								type: 'linear',
								x: 1,
								y: 0,
								x2: 0.5,
								y2: 1,
								colorStops: [{
									offset: 1,
									color: 'rgba(36,71,95, 0)'
								}, {
									offset: 0.5,
									color: 'rgba(36,71,95, .25)'
								}, {
									offset: 0,
									color: 'rgba(36,71,95, 1)'
								}],
								globalCoord: false
							},
							// borderWidth: '1',//图表的边框宽度
							// borderColor: '#000',//图表的边框颜色
							shadowBlur: 5, //外部轮廓的阴影范围 一旦设置了内外都有阴影
							shadowColor: '#000', //外部轮廓的阴影颜色
							// itemStyle: {
							//     shadowBlur:100,//设置无用
							//     shadowColor: '#64bbe5',//设置无用
							//     opacity: 1 //设置无用
							// }
						},
						itemStyle: {
							opacity: 1, //波浪的透明度
							// shadowBlur:0,//波浪的阴影范围
							// shadowColor:'#64bbe5',//阴影颜色
						},
						label: {
							fontSize: 16,
							color: '#fff',
							fontWeight: 'normal',
							formatter: function(param) {
								var paramVal;
								if (param.value == 0 && (param.value + '').indexOf('.') < 1) {
									paramVal = '暂无数据'
								} else {
									paramVal = (param.value*100).toFixed(1) + 'mm';
								}
								return '近1小时雨量' + '\n\n' +
									'\n' + paramVal;
							},

						},
						emphasis: {
							itemStyle: {
								opacity: 1 //鼠标经过波浪颜色的透明度
							}
						},
						color: ['#acf9fe', '#64bbe5'],
						// color: ['#64bbe5'],//水波的颜色 对应的是data里面值
						// shape: 'circle',//水填充图的形状 circle默认圆形  rect圆角矩形  triangle三角形  diamond菱形  pin水滴状 arrow箭头状  还可以是svg的path
						center: ['50%', '50%'], //图表相对于盒子的位置 第一个是水平的位置 第二个是垂直的值 默认是[50%,50%]是在水平和垂直方向居中 可以设置百分比 也可以设置具体值
						radius: '98%', //图表的大小 值是圆的直径 可以是百分比 也可以是具体值 100%则占满整个盒子 默认是40%; 百分比下是根据宽高最小的一个为参照依据
						amplitude: '6%', //振幅 是波浪的震荡幅度 可以取具体的值 也可以是百分比 百分比下是按图标的直径来算
						waveLength: '88%',
						// phase:0 ,//波的相位弧度 默认情况下是自动
						// period: (value,index)=>{//控制波的移动速度 可以是函数 也可以是数字 两个参数  value 是data数据里面的值 index 是data值的索引

						//     return index*2000;
						// },
						direction: 'left', //波移动的速度 两个参数  left 从右往左 right 从左往右
						waveAnimation: true, //控制波动画的开关  值是布尔值 false 是关闭动画 true 是开启动画 也是默认值
						animationEasing: 'linear', //初始动画
						animationEasingUpdate: 'quarticInOut', //数据更新的动画效果
						animationDuration: 3000, //初始动画的时长，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更绚丽的初始动画效果
						animationDurationUpdate: 300 //数据更新动画的时长

					}],
					//backgroundColor: 'rgba(255,0,0,0.1)'容器背景颜色
				};
				that.rollechart.setOption(option);
				window.setTimeout(function() {
					that.rollechart.resize();
				}, 200)
			},
			//绘制水球图表
			drawballEchart1(item) {
				var dom = document.querySelector(".rollechart1");
				that.rollechart1 = that.$echarts.init(dom);
				if (item == '暂无数据') {
					var value = [0, 0]
				} else {
          item=item/100;
          var value = [item, item]
				}
				var option = {

					series: [{
						type: 'liquidFill', //类型
						radius: '80%',
						data: value, //数据是个数组 数组的每一项的值是0-1
						outline: {
							show: true, //是否显示轮廓 布尔值
							borderDistance: 0, //外部轮廓与图表的距离 数字
							itemStyle: {
								//borderColor:'#5aa9d1', //边框的颜色
								borderColor: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(85, 144, 176, 1)'
									}, {
										offset: 0.5,
										color: 'rgba(85, 144, 176, .25)'
									}, {
										offset: 1,
										color: 'rgba(85, 144, 176, 1)'
									}],
									globalCoord: false
								},
								borderWidth: 0, //边框的宽度
								//shadowBlur: 25 , //外部轮廓的阴影范围 一旦设置了内外都有阴影
								//shadowColor: '#000' //外部轮廓的阴影颜色
							}
						},
						backgroundStyle: {
							//color:'rgba(36,71,95,0.5)',//图表的背景颜色
							color: {
								type: 'linear',
								x: 1,
								y: 0,
								x2: 0.5,
								y2: 1,
								colorStops: [{
									offset: 1,
									color: 'rgba(36,71,95, 0)'
								}, {
									offset: 0.5,
									color: 'rgba(36,71,95, .25)'
								}, {
									offset: 0,
									color: 'rgba(36,71,95, 1)'
								}],
								globalCoord: false
							},
							// borderWidth: '1',//图表的边框宽度
							// borderColor: '#000',//图表的边框颜色
							shadowBlur: 5, //外部轮廓的阴影范围 一旦设置了内外都有阴影
							shadowColor: '#000', //外部轮廓的阴影颜色
							// itemStyle: {
							//     shadowBlur:100,//设置无用
							//     shadowColor: '#64bbe5',//设置无用
							//     opacity: 1 //设置无用
							// }
						},
						itemStyle: {
							opacity: 1, //波浪的透明度
							// shadowBlur:0,//波浪的阴影范围
							// shadowColor:'#64bbe5',//阴影颜色
						},
						label: {
							fontSize: 16,
							color: '#fff',
							fontWeight: 'normal',
							formatter: function(param) {
								var paramVal;
								if (param.value == 0 && (param.value + '').indexOf('.') < 1) {
									paramVal = '暂无数据'
								} else {
									paramVal = (param.value*100).toFixed(1) + 'mm';
								}
								return '近3小时雨量' + '\n\n' +
									'\n' + paramVal;
							},

						},
						emphasis: {
							itemStyle: {
								opacity: 1 //鼠标经过波浪颜色的透明度
							}
						},
						color: ['#acf9fe', '#64bbe5'],
						// color: ['#64bbe5'],//水波的颜色 对应的是data里面值
						// shape: 'circle',//水填充图的形状 circle默认圆形  rect圆角矩形  triangle三角形  diamond菱形  pin水滴状 arrow箭头状  还可以是svg的path
						center: ['50%', '50%'], //图表相对于盒子的位置 第一个是水平的位置 第二个是垂直的值 默认是[50%,50%]是在水平和垂直方向居中 可以设置百分比 也可以设置具体值
						radius: '98%', //图表的大小 值是圆的直径 可以是百分比 也可以是具体值 100%则占满整个盒子 默认是40%; 百分比下是根据宽高最小的一个为参照依据
						amplitude: '6%', //振幅 是波浪的震荡幅度 可以取具体的值 也可以是百分比 百分比下是按图标的直径来算
						waveLength: '88%',
						// phase:0 ,//波的相位弧度 默认情况下是自动
						// period: (value,index)=>{//控制波的移动速度 可以是函数 也可以是数字 两个参数  value 是data数据里面的值 index 是data值的索引

						//     return index*2000;
						// },
						direction: 'left', //波移动的速度 两个参数  left 从右往左 right 从左往右
						waveAnimation: true, //控制波动画的开关  值是布尔值 false 是关闭动画 true 是开启动画 也是默认值
						animationEasing: 'linear', //初始动画
						animationEasingUpdate: 'quarticInOut', //数据更新的动画效果
						animationDuration: 3000, //初始动画的时长，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更绚丽的初始动画效果
						animationDurationUpdate: 300 //数据更新动画的时长

					}],
					//backgroundColor: 'rgba(255,0,0,0.1)'容器背景颜色
				};
				that.rollechart1.setOption(option);
				window.setTimeout(function() {
					that.rollechart1.resize();
				}, 200)
			},
			//绘制水球图表
			drawballEchart2(item) {
				var dom = document.querySelector(".rollechart2");
				that.rollechart2 = that.$echarts.init(dom);
				if (item == '暂无数据') {
					var value = [0, 0]
				} else {
          item=item/100;
          var value = [item, item]
				}
				var option = {

					series: [{
						type: 'liquidFill', //类型
						radius: '80%',
						data: value, //数据是个数组 数组的每一项的值是0-1
						outline: {
							show: true, //是否显示轮廓 布尔值
							borderDistance: 0, //外部轮廓与图表的距离 数字
							itemStyle: {
								//borderColor:'#5aa9d1', //边框的颜色
								borderColor: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(85, 144, 176, 1)'
									}, {
										offset: 0.5,
										color: 'rgba(85, 144, 176, .25)'
									}, {
										offset: 1,
										color: 'rgba(85, 144, 176, 1)'
									}],
									globalCoord: false
								},
								borderWidth: 0, //边框的宽度
								//shadowBlur: 25 , //外部轮廓的阴影范围 一旦设置了内外都有阴影
								//shadowColor: '#000' //外部轮廓的阴影颜色
							}
						},
						backgroundStyle: {
							//color:'rgba(36,71,95,0.5)',//图表的背景颜色
							color: {
								type: 'linear',
								x: 1,
								y: 0,
								x2: 0.5,
								y2: 1,
								colorStops: [{
									offset: 1,
									color: 'rgba(36,71,95, 0)'
								}, {
									offset: 0.5,
									color: 'rgba(36,71,95, .25)'
								}, {
									offset: 0,
									color: 'rgba(36,71,95, 1)'
								}],
								globalCoord: false
							},
							// borderWidth: '1',//图表的边框宽度
							// borderColor: '#000',//图表的边框颜色
							shadowBlur: 5, //外部轮廓的阴影范围 一旦设置了内外都有阴影
							shadowColor: '#000', //外部轮廓的阴影颜色
							// itemStyle: {
							//     shadowBlur:100,//设置无用
							//     shadowColor: '#64bbe5',//设置无用
							//     opacity: 1 //设置无用
							// }
						},
						itemStyle: {
							opacity: 1, //波浪的透明度
							// shadowBlur:0,//波浪的阴影范围
							// shadowColor:'#64bbe5',//阴影颜色
						},
						label: {
							fontSize: 16,
							color: '#fff',
							fontWeight: 'normal',
							formatter: function(param) {
								var paramVal;
								if (param.value == 0 && (param.value + '').indexOf('.') < 1) {
									paramVal = '暂无数据'
								} else {
									paramVal = (param.value*100).toFixed(1) + 'mm';
								}
								return '近6小时雨量' + '\n\n' +
									'\n' + paramVal;
							},

						},
						emphasis: {
							itemStyle: {
								opacity: 1 //鼠标经过波浪颜色的透明度
							}
						},
						color: ['#acf9fe', '#64bbe5'],
						// color: ['#64bbe5'],//水波的颜色 对应的是data里面值
						// shape: 'circle',//水填充图的形状 circle默认圆形  rect圆角矩形  triangle三角形  diamond菱形  pin水滴状 arrow箭头状  还可以是svg的path
						center: ['50%', '50%'], //图表相对于盒子的位置 第一个是水平的位置 第二个是垂直的值 默认是[50%,50%]是在水平和垂直方向居中 可以设置百分比 也可以设置具体值
						radius: '98%', //图表的大小 值是圆的直径 可以是百分比 也可以是具体值 100%则占满整个盒子 默认是40%; 百分比下是根据宽高最小的一个为参照依据
						amplitude: '6%', //振幅 是波浪的震荡幅度 可以取具体的值 也可以是百分比 百分比下是按图标的直径来算
						waveLength: '88%',
						// phase:0 ,//波的相位弧度 默认情况下是自动
						// period: (value,index)=>{//控制波的移动速度 可以是函数 也可以是数字 两个参数  value 是data数据里面的值 index 是data值的索引

						//     return index*2000;
						// },
						direction: 'left', //波移动的速度 两个参数  left 从右往左 right 从左往右
						waveAnimation: true, //控制波动画的开关  值是布尔值 false 是关闭动画 true 是开启动画 也是默认值
						animationEasing: 'linear', //初始动画
						animationEasingUpdate: 'quarticInOut', //数据更新的动画效果
						animationDuration: 3000, //初始动画的时长，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更绚丽的初始动画效果
						animationDurationUpdate: 300 //数据更新动画的时长

					}],
					//backgroundColor: 'rgba(255,0,0,0.1)'容器背景颜色
				};
				that.rollechart2.setOption(option);
				window.setTimeout(function() {
					that.rollechart2.resize();
				}, 200)
			},
			//绘制水球图表
			drawballEchart3(item) {
				var dom = document.querySelector(".rollechart3");
				that.rollechart3 = that.$echarts.init(dom);
				if (item == '暂无数据') {
					var value = [0, 0]
				} else {
					item=item/100;
					var value = [item, item]
				}
				var option = {

					series: [{
						type: 'liquidFill', //类型
						radius: '80%',
						data: value, //数据是个数组 数组的每一项的值是0-1
						outline: {
							show: true, //是否显示轮廓 布尔值
							borderDistance: 0, //外部轮廓与图表的距离 数字
							itemStyle: {
								//borderColor:'#5aa9d1', //边框的颜色
								borderColor: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(85, 144, 176, 1)'
									}, {
										offset: 0.5,
										color: 'rgba(85, 144, 176, .25)'
									}, {
										offset: 1,
										color: 'rgba(85, 144, 176, 1)'
									}],
									globalCoord: false
								},
								borderWidth: 0, //边框的宽度
								//shadowBlur: 25 , //外部轮廓的阴影范围 一旦设置了内外都有阴影
								//shadowColor: '#000' //外部轮廓的阴影颜色
							}
						},
						backgroundStyle: {
							//color:'rgba(36,71,95,0.5)',//图表的背景颜色
							color: {
								type: 'linear',
								x: 1,
								y: 0,
								x2: 0.5,
								y2: 1,
								colorStops: [{
									offset: 1,
									color: 'rgba(36,71,95, 0)'
								}, {
									offset: 0.5,
									color: 'rgba(36,71,95, .25)'
								}, {
									offset: 0,
									color: 'rgba(36,71,95, 1)'
								}],
								globalCoord: false
							},
							// borderWidth: '1',//图表的边框宽度
							// borderColor: '#000',//图表的边框颜色
							shadowBlur: 5, //外部轮廓的阴影范围 一旦设置了内外都有阴影
							shadowColor: '#000', //外部轮廓的阴影颜色
							// itemStyle: {
							//     shadowBlur:100,//设置无用
							//     shadowColor: '#64bbe5',//设置无用
							//     opacity: 1 //设置无用
							// }
						},
						itemStyle: {
							opacity: 1, //波浪的透明度
							// shadowBlur:0,//波浪的阴影范围
							// shadowColor:'#64bbe5',//阴影颜色
						},
						label: {
							fontSize: 16,
							color: '#fff',
							fontWeight: 'normal',
							formatter: function(param) {
								var paramVal;
								if (param.value == 0 && (param.value + '').indexOf('.') < 1) {
									paramVal = '暂无数据'
								} else {
									paramVal = (param.value*100).toFixed(1) + 'mm';
								}
								return '近12小时雨量' + '\n\n' +
									'\n' + paramVal;
							},

						},
						emphasis: {
							itemStyle: {
								opacity: 1 //鼠标经过波浪颜色的透明度
							}
						},
						color: ['#acf9fe', '#64bbe5'],
						// color: ['#64bbe5'],//水波的颜色 对应的是data里面值
						// shape: 'circle',//水填充图的形状 circle默认圆形  rect圆角矩形  triangle三角形  diamond菱形  pin水滴状 arrow箭头状  还可以是svg的path
						center: ['50%', '50%'], //图表相对于盒子的位置 第一个是水平的位置 第二个是垂直的值 默认是[50%,50%]是在水平和垂直方向居中 可以设置百分比 也可以设置具体值
						radius: '98%', //图表的大小 值是圆的直径 可以是百分比 也可以是具体值 100%则占满整个盒子 默认是40%; 百分比下是根据宽高最小的一个为参照依据
						amplitude: '6%', //振幅 是波浪的震荡幅度 可以取具体的值 也可以是百分比 百分比下是按图标的直径来算
						waveLength: '88%',
						// phase:0 ,//波的相位弧度 默认情况下是自动
						// period: (value,index)=>{//控制波的移动速度 可以是函数 也可以是数字 两个参数  value 是data数据里面的值 index 是data值的索引

						//     return index*2000;
						// },
						direction: 'left', //波移动的速度 两个参数  left 从右往左 right 从左往右
						waveAnimation: true, //控制波动画的开关  值是布尔值 false 是关闭动画 true 是开启动画 也是默认值
						animationEasing: 'linear', //初始动画
						animationEasingUpdate: 'quarticInOut', //数据更新的动画效果
						animationDuration: 3000, //初始动画的时长，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更绚丽的初始动画效果
						animationDurationUpdate: 300 //数据更新动画的时长

					}],
					//backgroundColor: 'rgba(255,0,0,0.1)'容器背景颜色
				};
				that.rollechart3.setOption(option);
				window.setTimeout(function() {
					that.rollechart3.resize();
				}, 200)
			},
			//绘制水球图表
			drawballEchart4(item) {
				var dom = document.querySelector(".rollechart4");
				that.rollechart4 = that.$echarts.init(dom);
				if (item == '暂无数据') {
					var value = [0, 0]
				} else {
					item=item/100;
					var value = [item, item]
				}
				var option = {

					series: [{
						type: 'liquidFill', //类型
						radius: '80%',
						data: value, //数据是个数组 数组的每一项的值是0-1
						outline: {
							show: true, //是否显示轮廓 布尔值
							borderDistance: 0, //外部轮廓与图表的距离 数字
							itemStyle: {
								//borderColor:'#5aa9d1', //边框的颜色
								borderColor: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(85, 144, 176, 1)'
									}, {
										offset: 0.5,
										color: 'rgba(85, 144, 176, .25)'
									}, {
										offset: 1,
										color: 'rgba(85, 144, 176, 1)'
									}],
									globalCoord: false
								},
								borderWidth: 0, //边框的宽度
								//shadowBlur: 25 , //外部轮廓的阴影范围 一旦设置了内外都有阴影
								//shadowColor: '#000' //外部轮廓的阴影颜色
							}
						},
						backgroundStyle: {
							//color:'rgba(36,71,95,0.5)',//图表的背景颜色
							color: {
								type: 'linear',
								x: 1,
								y: 0,
								x2: 0.5,
								y2: 1,
								colorStops: [{
									offset: 1,
									color: 'rgba(36,71,95, 0)'
								}, {
									offset: 0.5,
									color: 'rgba(36,71,95, .25)'
								}, {
									offset: 0,
									color: 'rgba(36,71,95, 1)'
								}],
								globalCoord: false
							},
							// borderWidth: '1',//图表的边框宽度
							// borderColor: '#000',//图表的边框颜色
							shadowBlur: 5, //外部轮廓的阴影范围 一旦设置了内外都有阴影
							shadowColor: '#000', //外部轮廓的阴影颜色
							// itemStyle: {
							//     shadowBlur:100,//设置无用
							//     shadowColor: '#64bbe5',//设置无用
							//     opacity: 1 //设置无用
							// }
						},
						itemStyle: {
							opacity: 1, //波浪的透明度
							// shadowBlur:0,//波浪的阴影范围
							// shadowColor:'#64bbe5',//阴影颜色
						},
						label: {
							fontSize: 16,
							color: '#fff',
							fontWeight: 'normal',
							formatter: function(param) {
								var paramVal;
								if (param.value == 0 && (param.value + '').indexOf('.') < 1) {
									paramVal = '暂无数据'
								} else {
									paramVal = (param.value*100).toFixed(1) + 'mm';
								}
								return '近24小时雨量' + '\n\n' +
									'\n' + paramVal;
							},

						},
						emphasis: {
							itemStyle: {
								opacity: 1 //鼠标经过波浪颜色的透明度
							}
						},
						color: ['#acf9fe', '#64bbe5'],
						// color: ['#64bbe5'],//水波的颜色 对应的是data里面值
						// shape: 'circle',//水填充图的形状 circle默认圆形  rect圆角矩形  triangle三角形  diamond菱形  pin水滴状 arrow箭头状  还可以是svg的path
						center: ['50%', '50%'], //图表相对于盒子的位置 第一个是水平的位置 第二个是垂直的值 默认是[50%,50%]是在水平和垂直方向居中 可以设置百分比 也可以设置具体值
						radius: '98%', //图表的大小 值是圆的直径 可以是百分比 也可以是具体值 100%则占满整个盒子 默认是40%; 百分比下是根据宽高最小的一个为参照依据
						amplitude: '6%', //振幅 是波浪的震荡幅度 可以取具体的值 也可以是百分比 百分比下是按图标的直径来算
						waveLength: '88%',
						// phase:0 ,//波的相位弧度 默认情况下是自动
						// period: (value,index)=>{//控制波的移动速度 可以是函数 也可以是数字 两个参数  value 是data数据里面的值 index 是data值的索引

						//     return index*2000;
						// },
						direction: 'left', //波移动的速度 两个参数  left 从右往左 right 从左往右
						waveAnimation: true, //控制波动画的开关  值是布尔值 false 是关闭动画 true 是开启动画 也是默认值
						animationEasing: 'linear', //初始动画
						animationEasingUpdate: 'quarticInOut', //数据更新的动画效果
						animationDuration: 3000, //初始动画的时长，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更绚丽的初始动画效果
						animationDurationUpdate: 300 //数据更新动画的时长

					}],
					//backgroundColor: 'rgba(255,0,0,0.1)'容器背景颜色
				};
				that.rollechart4.setOption(option);
				window.setTimeout(function() {
					that.rollechart4.resize();
				}, 200)
			},
      getWarning(alarm){
        var that = this
        that.warningObj = alarm;
        // if (that.warningObj.length == 0) {
        // 	that.swiperShow = false
        // } else {
        // 	that.swiperShow = true
        // }
        if (that.warningObj.length > 0) {
        that.$nextTick(function() {
        	// var swiper = new Swiper("#warningSwiper", {
        	// 	loop: false,
        	// 	autoplay: true,
        	// 	direction: 'vertical',
        	// 	updateOnImagesReady: true,
        	// 	noSwiping: true,
        	// 	noSwipingSelector: ".zheLine",
        	// 	initialSlide: 0,
        	// 	pagination: {
        	// 		el: ".swiper-pagination"
        	// 	},
        	// });
          startmarquee(1000, 60, 10000);
        })
        }
      },
			// 预警
			getMapWarning(location) {
				var that = this
				requestData('https://geoapi.heweather.net/v2/city/lookup?location=' + location +
					'&key=ac85b829a6e24245895cccc39bdcad3a', 'get', '',
					function(res) {
						that.getMapWarningObj(res.location[0].id)
					})
			},
			getMapWarningObj(locationId) {
				var that = this
				requestData('https://devapi.heweather.net/v7/warning/now?location=' + locationId +
					'&key=ac85b829a6e24245895cccc39bdcad3a', 'get', '',
					function(res) {
						that.warningObj = res.warning;
						if (that.warningObj.length == 0) {
							that.swiperShow = false
						} else {
							that.swiperShow = true
						}
						that.$nextTick(function() {
							var swiper = new Swiper("#warn-swiper", {
								loop: false,
								autoplay: true,
								direction: 'vertical',
								updateOnImagesReady: true,
								noSwiping: true,
								noSwipingSelector: ".zheLine",
								initialSlide: 0,
								pagination: {
									el: ".swiper-pagination"
								},
							});
						})
					})
			},
			// banner: function() {
			// 	setTimeout(() => {
			// 		var swiper = new Swiper("#warningSwiper", {
			// 			autoplay: true, //是否自动滚动
			// 			loop: true, //是否可以循环
			// 			direction: 'vertical',
			// 			updateOnImagesReady: true,
			// 			noSwiping: true,
			// 			noSwipingSelector: ".zheLine",
			// 			initialSlide: 0,
			// 			observer: true, //修改swiper自己或子元素时，自动初始化swiper
			// 			observeParents: true, //修改swiper的父元素时，自动初始化swiper
			// 		});
			// 	}, 100);

			// }
			banner: function() {

			},
      fetchData:function(){
        var that = this;
        var res_data=[];
        if(that.expDate.length>0){
          var startTime=that.expDate[0].format("yyyy-MM-dd");
          startTime+=" 00";
          var endTime=that.expDate[1].format("yyyy-MM-dd");
          endTime+=" 23";
          var newUrl = baseUrl + 'hour/queryByTime?sessionId=' + that.sessionId + '&start=' + startTime + '&end=' + endTime +
          	'&code=' + that.userInfo.codeId;
          requestData(newUrl, 'get', '', function(res) {
          	if (res.message == "查询成功！") {
                res_data=res.responseBody.datas;
            }
          },false);
        }
        return res_data;
      },
      startDownload(){
        console.log("开始下载");
      },
      finishDownload(){
         console.log("下载完成");
      },
      formatDateByTimes(times, fmt) {
          var d = new Date(times);
          var o = {
              "M+": d.getMonth() + 1, //月份
              "d+": d.getDate(), //日
              "h+": d.getHours(), //小时
              "m+": d.getMinutes(), //分
              "s+": d.getSeconds(), //秒
              "q+": Math.floor((d.getMonth() + 3) / 3), //季度
              "S": d.getMilliseconds() //毫秒
          };
          if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
          for (var k in o)
              if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
          return fmt;
      }
		},
	};

  function startmarquee(lh, speed, delay) {
    var t;
    var o = document.getElementById("warn-swiper");
    var oHeight = 80; /** div的高度 **/
    var p = false;

    var preTop = 0;
    o.scrollTop = 0;

    function start() {
      t = setInterval(scrolling, speed);
      o.scrollTop += 1;
    }

    function scrolling() {
      console.log(o.scrollTop)
      if (o.scrollTop % lh != 0 && o.scrollTop % (o.scrollHeight - oHeight - 1) != 0) {
        preTop = o.scrollTop;
        o.scrollTop += 1;
        if (preTop >= o.scrollHeight || preTop == o.scrollTop) {
          o.scrollTop = 0;
        }
      }else {
        clearInterval(t);
        setTimeout(start, delay);
      }
    }
    setTimeout(start, delay);
  }
</script>

<style scoped>
	body,
	html {
		font-size: 12px !important;
	}

	.index-contain {
		background: #275f73;
		height: 100%;
		position: absolute;

	}

	.header {
		width: 100%;
		background-color: #367b94;
		height: 1.01rem;
		line-height: 1.01rem;
		font-size: 0.3rem;
		font-family: PingFangSC;
		font-weight: 400;
		color: #FFFFFF;
		text-align: center;
	}

	.header img {
		height: 0.58rem;
		width: 0.58rem;
		vertical-align: middle;
		margin-right: 0.18rem;
	}

	.container {
		position: absolute;
		top: 1.01rem;
		width: 100%;
		z-index: 2;
		/* bottom:0; */
		height: calc(100% - 1.01rem);
		box-sizing: border-box;
		padding-left: 1.68rem;
		padding-right: 0.58rem;
		overflow: auto;
		scrollbar-width: none;
		-ms-overflow-style: none;
		/* IE 10+ */
	}

	.container::-webkit-scrollbar {
		display: none;
		/* Chrome Safari */
	}

	.container>div {
		float: left;
		padding-top: 0.47rem;
	}

	.container>div:nth-child(1) {
		width: 3.23rem;
		min-height: 2rem;
		/* overflow: hidden; */
	}

	.schoolname {
		color: #fff;
		font-size: 0.26rem;
		font-family: PingFangSC;
		font-weight: 500;
		line-height: 0.37rem;
		text-align: center;
		white-space: nowrap;
		display: flex;
		justify-content: space-around;
	}

	.schoolname label {
		color: #fff;
		font-weight: bold;
	}

	.time {

		font-size: 0.16rem;
		font-family: PingFangSC;
		font-weight: 400;
		color: #fff;
		text-align: center;
		margin-top: 0.11rem;
		margin-bottom: 0.03rem;
	}

	.line {
		width: 100%;
		height: 0.03rem;
		background: linear-gradient(90deg, #9DEDFF 0%, #BDE595 100%);
	}

	.detail {
		padding-left: 0.76rem;
		padding-top: 0.18rem;
		position: relative
	}

	.detail-say {
		margin-bottom: 0.22rem;
		display: flex;
	}
	.trsdshow .detail-say{
		margin-bottom: 0.15rem;
	}
	.nomgb {
		margin-bottom: 0 !important;
	}

	.det-img {
		height: 0.33rem;
		width: 0.32rem;
		overflow: hidden;
		text-align: center;
		display: inline-block;
		margin-right: 0.2rem;
	}
	.detail > p{
		position: relative;
		top: -0.1rem;
		white-space: nowrap;
	}
	.detail-say img {
		display: inline-block;
		vertical-align: middle;
		height: 0.28rem;
	}

	.detail-say label {
		color: #fff;
		line-height: 0.33rem;
		font-size: 0.18rem;
		font-family: PingFangSC;
		font-weight: normal;
		letter-spacing: 0.001rem;
		white-space: nowrap;
	}
	.detail-say label span{
		font-weight: bold;
	}
	.detail-title {
		position: absolute;
		top: 50%;
		left: -0.1rem;
		font-size: 0.24rem;
		padding-left: 0.09rem;
		padding-right: 0.09rem;
		height: 1.32rem;
		background: #479ed1;
		border-radius: 0.25rem;
		color: #fff;
		margin-top: -0.66rem;
		writing-mode: tb;
		text-align: center;

	}

	.short {

		height: 1.07rem !important;
		margin-top: -0.535rem !important;
	}

	.container>div:nth-child(2) {
		width: calc(100% - 3.23rem);
		padding-left: 0.26rem;
		box-sizing: border-box;
	}

	@media (max-width: 1366px) {
		.container>div:nth-child(2) {
			width: calc(100% - 3.53rem);
		}

		.container>div:nth-child(1) {
			width: 3.53rem;
		}

		.detail-say label {
			font-size: 0.23rem;
		}

		.detail-title {
			left: -0.08rem;
		}
	}

	.tutu-name {
		font-size: 0.28rem;
		font-family: PingFangSC;
		font-weight: 400;
		color: #fff;
		text-align: center;
	}

	.tuechart {
		width: 100%;
		height: 3.4rem;

	}

	.tutu2 {
		display: flex;
	}

	.tutu2 .sevenechart {
		width: 8.16rem;
		min-height: 3.57rem;
		margin-top: 0.3rem;
		margin-bottom: 0.49rem;
		overflow: hidden;
		position: relative;

	}

	.sevenechartcont {
		position: absolute;
		right: 0;
		left: 1.02rem;
		top: 1.1rem;
		bottom: 0.75rem;
	}

	.sevenechart>.div {
		width: 1.02rem;
		float: left;
		text-align: center;
		min-height: 3.57rem;
		color: #fff;
		border-right: 1px solid #F3F3F3;
		box-sizing: border-box;

	}

	.sevenechart>div:last-child {
		border: 0
	}

	.sevenechart>div>div {
		color: #fff;
	}

	.week {

		font-size: 0.22rem;
		font-family: PingFangSC;
		font-weight: 400;
		color: #FFFFFF;
	}

	.date {

		font-size: 0.22rem;
		font-family: PingFangSC;
		font-weight: 400;
		color: #FFFFFF;
		margin-top: 0.18rem;
	}

	.imgsay,
	.imgsay0 {
		text-align: center;
		margin-top: 0.1rem;
	}

	.imgsay0 {
		margin-top: 1.7rem;
	}

	.imgsay img,
	.imgsay0 img {
		width: 0.42rem;
		height: 0.42rem;
	}

	.daynight {
		height: 100%;
	}

	.daynight>div:nth-child(1) {
		height: 50%;
		padding-top: 0.6rem;
		/* 	padding-bottom:0.401rem; */
		box-sizing: border-box;

	}

	.daynight>div:nth-child(2) {
		height: 50%;
		padding-top: 0.401rem;
		box-sizing: border-box;


	}

	.qiuechart {
		width: 3.12rem;
		height: 3.12rem;
		margin-top: 0.52rem;
		margin-left: 0.69rem;
		position: relative;
		border-radius: 50%;
		border: 3px solid rgba(85, 144, 176, .5);
		overflow: hidden;
	}

	.add {
		position: absolute;
		top: 3px;
		left: 3px;
		width: calc(100% - 8px);
		height: calc(100% - 8px);
		text-align: right;
		border-radius: 50%;
		padding-right: .5rem;
		padding-top: 10px;
		box-sizing: border-box;
		box-shadow: 0 0 30px #12232e inset;
	}

	.add img {
		width: 1.4rem;
		height: 0.95rem;


	}

	.rollechart,
	.rollechart1,
	.rollechart2,
	.rollechart3,
	.rollechart4 {
		width: 3.12rem;
		height: 3.12rem;
	}

	.footer {
		position: absolute;
		bottom: 0;
		z-index: 1;
		width: 100%;
		opacity: .85;
	}

	.footer img {
		width: 100%;
		vertical-align: bottom;
	}

	.swiper-box,
	.swiper-box .swiper-container{
		height: 0.80rem;
	}

	.swiper-box .swiper-slide {
		height: 0.72rem;
	}

	#qiuechartSwiper {
		width: 100%;
		height: 100%;
	}

	#qiuechartSwiper .swiper-slide {
		text-align: center;

		/* Center slide text vertically */
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
		transition: 300ms;
		transform: scale(0.8);
	}

	#qiuechartSwiper .swiper-slide-active,
	.swiper-slide-duplicate-active {
		transform: scale(1);
	}

  .m-warning {
    position: absolute;
    height: 100%;
    overflow: hidden;
    right: 30px;
    top: 0;
    width: 6.3rem;
  }
  .warn_conten {
    display: flex;
    align-items: center;
    padding: 10px 0;
    position: relative;
  }
  .warn-swiper {
    height: 100%;
    width: 100%;
    padding-right: 50px;
    overflow: auto;
  }
  .m-warning img {
    width: 0.72rem;
    height: 0.6rem;
    margin-right: 0.2rem;
    position: absolute;
    top: 0.2rem;
  }
  .warn_txt h4 {
    width: 100%;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    line-height: 26px;
    margin-bottom: 8px;
    text-align: left;
  }
  .warn_txt span {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #fff;
    display: block;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
  }
  .container_words{
    position: relative;
    /* 盒子背景宽度将随文字宽度而进行自适应 */
    width: fit-content;
    animation: move 20s linear infinite;
    padding-left: 20px;
  }
  .container_words::after {
      position: absolute;
      right: -100%;
      content: attr(text);
  }
  @keyframes move {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-100%);
      }
  }
  .warn_txt {
    width: 5.38rem;
    margin-left: 0.92rem;
  }

</style>



// WEBPACK FOOTER //
// src/page/dp/dp.vue